<template>
  <div class="errPage-container">
    <el-row>

      <el-col :span="24" style="text-align: center">
        <img :src="bugImg" width="300" height="160" alt="Girl has dropped her ice cream.">
      </el-col>
      <el-col :span="24" style="text-align: center">
        <div class="text-jumbo ">您目前可访问的菜单为空，没有可访问的权限。</div>
        <div >您可以通过以下方式进行处理：</div>
        <div style="background: rgba(247,249,251,.996);padding: 20px;display: inline-block">请联系管理员对您的账号授权</div>


<!--        <el-button plain type="primary"  style="margin-top: 1.25rem" size="small" @click="goHome">返回首页</el-button>-->
      </el-col>

    </el-row>
  </div>
</template>

<script>
import bugImg from '../../../../static/qlrtu_query/wr.png'

export default {
  name: 'Page401',
  data() {
    return {
      bugImg:bugImg,
      baseUrl:process.env.VUE_APP_CHIBIAO_OUT_URL,
    }
  },
  methods: {

    goHome(){
      window.location.href = this.baseUrl

    },

  }
}
</script>

<style lang="less" scoped>
  .errPage-container {
    width: 800px;
    max-width: 100%;
    margin: 100px auto;
    .pan-back-btn {
      background: #008489;
      color: #fff;
      border: none!important;
    }
    .pan-gif {
      margin: 0 auto;
      display: block;
    }
    .pan-img {
      display: block;
      margin: 0 auto;
      width: 100%;
    }
    .text-jumbo {
      font-size: 1.5rem;
      font-weight: 700;
      color: #484848;
    }
    .list-unstyled {
      font-size: 14px;
      li {
        padding-bottom: 5px;
      }
      a {
        color: #008489;
        text-decoration: none;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/comm/components/error/401.vue